import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { Filter } from '@budget-monorepo/shared-ui';

const PlanFilter = ({ path }) => {
  const staticRender = {
    render: ({ filterData }) => {
      const newFilterOptions = [];
      let i = 0;
      const dataLength = filterData.planItems.length;
      for (; i < dataLength; i += 1) {
        const item = filterData.planItems[i]; // target
        // Suppress plan item with "suppressed" flag
        if (!item.suppressed) {
          const newFields = {
            account: item.planItemNumber,
            description: item.planItemName
          }; // source
          // normalize filter data by adding account and description fields
          newFilterOptions.push(Object.assign(item, newFields));
        }
      }

      const filterProps = {
        path,
        pathRoot: '/beneficiary-agency/',
        filterData: newFilterOptions,
        fuzzyDisplay: {
          label: 'Search for a plan item',
          id: 'plan-item-search',
          inputId: 'plan-item-search-input',
          placeholder: 'Enter plan item number or name'
        },
        orgDisplay: {
          label: 'Search for a beneficiary agency',
          id: 'state-organization',
          inputId: 'state-organization-input',
          placeholder: 'Enter an agency name'
        }
      };
      return<Filter {...filterProps} />;
    }
  };

  return(
    <StaticQuery
      query={graphql`
          query {
            filterData: pagesJson(fields: {slug: { eq: "/plan-item/"}}) {
              planItems {
                suppressed
                planItemNumber
                planItemName
                govLevelTwo
                govLevelTwoDisplay
                govLevelOne
                govLevelOneDisplay
              }
            }
          }
        `}
      {...staticRender}
    />
  );
};

PlanFilter.propTypes = {
  /* Relative path passed from the page/template excluding path prefix */
  path: PropTypes.string,
  /* Data array of planItem object, see the graphql queried object above */
  filterData: PropTypes.array
};

export default PlanFilter;
